import React from 'react';
import PropTypes from 'prop-types';
import { DeviceMeta } from 'Roblox';
import PremiumService from '../services/premiumService';

const { isInApp } = DeviceMeta();

function CatalogBenefitSection({ translate }) {
  const description = isInApp
    ? translate('Description.GetAccessToAvatarShop', {
        linkStart: ``,
        linkEnd: ''
      })
    : translate('Description.GetAccessToAvatarShop', {
        linkStart: isInApp
          ? ''
          : `<a class='text-link' href='${PremiumService.getPremiumCatalogUrl()}' target='_blank'>`,
        linkEnd: isInApp ? '' : '</a>'
      });
  return (
    <div className='catalog-benefit-section'>
      <div className='bg-container' />
      <div className='characters tiger-captain' />
      <div className='catalog-benefit-header right-header'>
        <div className='font-title'>{translate('Heading.ExclusiveItem')}</div>
        <div className='font-header-2 text-subheader'>
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    </div>
  );
}

CatalogBenefitSection.propTypes = {
  translate: PropTypes.func.isRequired
};
export default CatalogBenefitSection;
